import { render, staticRenderFns } from "./ClbrtnHistSearch.vue?vue&type=template&id=4560f9c6&scoped=true"
import script from "./ClbrtnHistSearch.vue?vue&type=script&lang=js"
export * from "./ClbrtnHistSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560f9c6",
  null
  
)

export default component.exports